import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import CmsApp from '../CmsApp';
import { CMS_API_BASE } from 'app/config/env';
import { fetchCmsAccessTokenWithMeta, getCachedCmsAccessToken, startCmsTokenAutoRefresh, } from 'shared/api/cms-auth';
const CmsTokenBootstrap = ({ getWalletAccessToken, walletApiBase }) => {
    const [status, setStatus] = useState('loading');
    const [error, setError] = useState(null);
    const tokenRef = useRef('');
    useEffect(() => {
        let cancelled = false;
        let stopRefresh = () => undefined;
        const boot = async () => {
            try {
                const result = await fetchCmsAccessTokenWithMeta();
                if (cancelled) {
                    return;
                }
                tokenRef.current = result.token;
                setError(null);
                setStatus('ready');
                stopRefresh = startCmsTokenAutoRefresh(token => {
                    tokenRef.current = token;
                });
            }
            catch (err) {
                if (cancelled) {
                    return;
                }
                setError(err instanceof Error ? err.message : 'Failed to fetch CMS access token.');
                setStatus('error');
            }
        };
        void boot();
        return () => {
            cancelled = true;
            stopRefresh();
        };
    }, []);
    const getAccessToken = useCallback(() => tokenRef.current || getCachedCmsAccessToken() || '', []);
    if (status === 'error') {
        return (_jsxs("div", { className: "cms-iframe-shell cms-iframe-shell--error", children: [_jsx("p", { children: error ?? 'Failed to fetch CMS access token.' }), _jsx("p", { className: "cms-iframe-shell__hint", children: "CMS fetches its API token from the wallet Keycloak endpoint configured at build time." })] }));
    }
    if (status !== 'ready') {
        return (_jsxs("div", { className: "cms-iframe-shell cms-iframe-shell--waiting", children: [_jsx("i", { className: "pi pi-spin pi-spinner cms-iframe-shell__spinner", "aria-hidden": true }), _jsx("p", { children: "Fetching CMS access token\u2026" })] }));
    }
    return (_jsx(CmsApp, { apiBaseUrl: CMS_API_BASE, getAccessToken: getAccessToken, getWalletAccessToken: getWalletAccessToken, walletApiBase: walletApiBase }));
};
export default CmsTokenBootstrap;
